import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalOverlay from './../ModalOverlay.jsx';
import { MediaContext } from '../../MediaContext';
import './ComposableVideo.css';

const ComposableVideo = ({ mediaContext, src, style }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        mediaContext.setIsVideoPlaying(true);

        return () => {
            return mediaContext.setIsVideoPlaying(false);
        };
    }, []);

    const onPlay = () => {
        setIsPlaying(true);
    };

    const onPause = () => {
        setIsPlaying(false);
    };

    const onStartLoad = () => {
        setIsLoading(true)
    }

    const onEndLoad = () => {
        setIsLoading(false)
    }

    return (
        <div className={isPlaying ? 'composableVideoPlaying' : ''}>
            <ModalOverlay />
            <video
                controls
                autoPlay
                preload='auto'
                style={style}
                onPlay={onPlay}
                onPause={onPause}
                onLoadStart={onStartLoad}
                onLoadedData={onEndLoad}
                width={isLoading ? '0' : 'auto'}
            >
                <source src={src} />
            </video>
        </div>
    );
}

ComposableVideo.propTypes = {
    src: PropTypes.string.isRequired,
    style: PropTypes.object
};

export default props => (
    <MediaContext.Consumer>
        {mediaContextValue => (
            <ComposableVideo
                mediaContext={mediaContextValue}
                {...props}
            />
        )}
    </MediaContext.Consumer>
)

